import {useContext, useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import Select, {formSelectSizes} from '@adv-mt/mt-form-select'

const mapOption = ({value, text}) => ({id: value, label: text})
const mapSelectOption = ({items}) => items.map(mapOption)

const FormTechnicalModelVersion = ({initialSearch = {}, value, onChange, pageName}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const {TECHNICAL_DETAILS_SEARCH_PAGE_NAME, TECHNICAL_DETAILS_SEARCH_RESULTS_PAGE_NAME} = config.get('page')
  const {VEHICLE_SPECS_CONTEXT, VEHICLE_SPEC_PARAMS} = config.get('vehicles')
  const [models, setModels] = useState([])
  const {makeId, categoryId} = initialSearch
  const placeholder = i18n.t('COMMON_ALL_MODELS')
  const FIRST_OPTION = {id: 0, label: placeholder}

  const isTechnicalDetailsSearchPage =
    pageName === TECHNICAL_DETAILS_SEARCH_PAGE_NAME || pageName === TECHNICAL_DETAILS_SEARCH_RESULTS_PAGE_NAME

  const extendedParams = isTechnicalDetailsSearchPage ? {} : VEHICLE_SPEC_PARAMS.MANUAL_ITEMS

  useEffect(() => {
    if (!makeId) return
    domain
      .get('get_specs_vehicles_use_case')
      .execute({
        nextField: VEHICLE_SPECS_CONTEXT.MODELS_VERSION,
        params: {makeId, categoryId, ...extendedParams}
      })
      .then(([error, response]) => {
        if (error) return

        const {items} = response
        const parsedItems = mapSelectOption({items})
        setModels([FIRST_OPTION, ...parsedItems])
      })

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categoryId, makeId])

  const handleChange = (e, {value}) => {
    const modelSelected = models.find(model => model.id === value)

    const nextValue = modelSelected && modelSelected.id

    return onChange(e, {
      field: FILTER_NAMES.MODEL_VERSION,
      value: nextValue,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.MODEL_VERSION]
    })
  }

  return (
    <Select
      size={formSelectSizes.LARGE}
      label={i18n.t('COMMON.PLURALS.MODEL', 1)}
      placeholder={placeholder}
      options={models}
      value={value}
      onChange={handleChange}
      disabled={!makeId}
    />
  )
}

FormTechnicalModelVersion.displayName = 'FormTechnicalModelVersion'
FormTechnicalModelVersion.propTypes = {
  initialSearch: PropTypes.shape({
    makeId: PropTypes.number
  }),
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  pageName: PropTypes.string
}

export default FormTechnicalModelVersion
